/******/ (() => { // webpackBootstrap
/* eslint-disable */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.isProcessing = false;
    this.cacheDOMElements();
    this.onSubmitBound = this.onSubmit.bind(this);
    this.handleQuickViewModal = this.handleQuickViewModal.bind(this);
  }

  cacheDOMElements() {
    this.form = this.querySelector('form');
    this.sectionId = this.getAttribute('data-section-id');
    this.productInformation = this.closest('product-information');
    this.cartAction = document.getElementById('PageContainer')?.dataset.cartAction;
    this.cartType = document.getElementById('PageContainer')?.dataset.cartType;
    this.cartCountIndicator = document.querySelector('[data-cart-count-indicator]');
    this.giftWrapProductId = this.getAttribute('data-gift-wrap-product-id');
    this.wethemeGlobal = document.querySelector('script#wetheme-global');
    this.translationsObject = this.wethemeGlobal ? JSON.parse(this.wethemeGlobal.textContent) : { translations: {} };
    this.qtyErrorMessage = this.querySelector('[data-qty-error-message]');
    this.blankElements = [];
  }

  connectedCallback() {
    if (!this.form) return;
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.form.addEventListener('submit', this.onSubmitBound);
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.isProcessing) return;
    this.prepareForSubmission();
  }

  prepareForSubmission() {
    this.cacheSubmissionElements();
    if (!this.checkRequiredInputs()) return;
    this.disableBlankInputs();
    this.showLoadingState();
    this.addItemsToCart();
  }

  cacheSubmissionElements() {
    this.loadingIcon = this.form.querySelector('[data-loading-icon]');
    this.addToCartText = this.form.querySelector('[data-add-to-cart-text]');
    this.addedText = this.form.querySelector('[data-cart-added-text]');
    this.quantityInput = this.form.querySelector('[name="quantity"]');
    this.quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;
  }

  disableBlankInputs() {
    if (!this.productInformation) return;
    const elements = this.productInformation.querySelectorAll('input, textarea');
    this.blankElements = [];
    elements.forEach((element) => {
      if (!element.value) {
        element.disabled = true;
        this.blankElements.push(element);
      }
    });
  }

  enableBlankInputs() {
    (this.blankElements || []).forEach((element) => { element.disabled = false; });
    this.blankElements = [];
  }

  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  checkRequiredInputs() {
    if (!this.productInformation) return true;
    const requiredInputs = Array.from(this.productInformation.querySelectorAll('[required]:not(:disabled):not([data-input-ignore])'));
    this.clearErrorMessages();
    const invalidInputs = requiredInputs.filter(input => input.type === 'checkbox' ? !input.checked : !String(input.value || '').trim());
    invalidInputs.forEach(input => this.applyErrorMessage(input));
    return invalidInputs.length === 0;
  }

  clearErrorMessages() {
    if (!this.productInformation) return;
    this.productInformation.querySelectorAll('.required-field-error').forEach(error => error.remove());
    this.productInformation.querySelectorAll('[aria-invalid="true"]').forEach(input => input.removeAttribute('aria-invalid'));
  }

  applyErrorMessage(input) {
    if (!input) return;
    if (!input.id) input.id = `mylill-required-${Math.random().toString(36).slice(2, 9)}`;
    const inputId = input.id;
    const errorId = `${inputId}-error`;
    const submitErrorId = `${inputId}-submit-error`;
    const buttonWrapper = this.querySelector('.paymentButtonsWrapper');
    const errorContainer = input.closest('.input-wrapper')?.querySelector('.input-error-container');
    const translations = this.translationsObject?.translations || {};
    const errorMessage = input.hasAttribute('custom-dropdown-input') ? translations.required_dropdown_error : input.type === 'file' ? translations.required_upload_error : input.type === 'checkbox' ? translations.required_checkbox_error : translations.required_input_error;
    const safeErrorMessage = errorMessage || 'Merci de renseigner ce champ.';
    const submitErrorMessage = input.type === 'file' ? input.closest('file-upload')?.dataset.errorMessage : input.dataset.errorMessage;
    const errorElement = `<span id="${errorId}" class="required-field-error errors" style="display:block" role="alert">${safeErrorMessage}</span>`;
    const submitErrorElement = submitErrorMessage ? `<span id="${submitErrorId}" class="required-field-error errors" style="display:block" role="alert">${submitErrorMessage}</span>` : '';
    errorContainer ? errorContainer.innerHTML = errorElement : input.insertAdjacentHTML('beforebegin', errorElement);
    if (buttonWrapper && submitErrorElement) buttonWrapper.insertAdjacentHTML('beforebegin', submitErrorElement);
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', errorId);
    input.focus();
    if (input.type === 'file') return;
    input.addEventListener('input', () => {
      this.productInformation?.querySelector(`#${CSS.escape(errorId)}`)?.remove();
      this.querySelector(`#${CSS.escape(submitErrorId)}`)?.remove();
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }, { once: true });
  }

  giftWrapEnabled() {
    const giftWrapProp = this.productInformation?.getAttribute('data-gift-wrap-prop');
    if (!giftWrapProp || !this.giftWrapProductId) return false;
    const name = `properties[${giftWrapProp}]`;
    const selector = `[name="${CSS.escape(name)}"]`;
    return !!this.productInformation.querySelector(selector)?.checked;
  }

  async addItemsToCart() {
    this.isProcessing = true;
    try {
      const mainProductAdded = await this.addProductToCart(routes.cart_add_url, this.fetchConfigWithBody());
      if (this.giftWrapEnabled()) {
        await this.addProductToCart(routes.cart_add_url, this.additionalProductConfig(this.giftWrapProductId, this.quantity));
      }
      this.processResponse(mainProductAdded);
    } catch (error) {
      console.error(`Error adding item(s) to cart: ${error.message || error}`);
      this.handleAddError(error);
    } finally {
      this.isProcessing = false;
      this.enableBlankInputs();
    }
  }

  async addProductToCart(url, config) {
    const response = await fetch(url, config);
    if (!response.ok) {
      let errorData = null;
      try { errorData = await response.clone().json(); } catch (e) {}
      const error = new Error(errorData?.description || errorData?.message || response.statusText || 'Impossible d’ajouter cet article au panier.');
      error.status = response.status;
      throw error;
    }
    if (this.cartType === 'drawer') {
      const responseJson = await response.json();
      this.updateCartDrawer(responseJson);
    }
    return response;
  }

  handleAddError(error) {
    this.toggleElements(this.loadingIcon, false, 'hidden');
    this.toggleAddToCartText(true);
    this.toggleAddButton(false);
    if (this.qtyErrorMessage) {
      this.qtyErrorMessage.textContent = error?.message || 'Impossible d’ajouter cet article au panier. Merci de réessayer.';
      this.qtyErrorMessage.classList.remove('hidden');
      this.qtyErrorMessage.setAttribute('role', 'alert');
    }
  }

  additionalProductConfig(productId, quantity) {
    const additionalItemPayload = { items: [{ id: productId, quantity: quantity }] };
    if (this.cartType === 'drawer') additionalItemPayload.sections = 'cart-drawer';
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(additionalItemPayload)
    };
  }

  updateCartDrawer(responseJson) {
    window.eventBus?.emit('update:cart:drawer', responseJson);
  }

  async getCart() {
    try {
      const response = await fetch(`${routes.cart_url}?view=compare`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error(`Error fetching cart: ${error.message || error}`);
      return null;
    }
  }

  updateCartCountIndicator() {
    if (!this.cartCountIndicator) return;
    this.getCart().then(cart => { if (cart) window.wetheme?.updateCartCount(cart); });
  }

  fetchConfigWithBody() {
    const config = this.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = this.addSectionsParam(new FormData(this.form));
    return config;
  }

  addSectionsParam(formData) {
    if (this.cartType === 'drawer') formData.append('sections', 'cart-drawer');
    return formData;
  }

  processResponse(response) {
    if (!response?.ok) return;
    this.hideLoadingState();
    window.eventBus?.emit('cart:added', { sectionId: this.sectionId });
    this.handleQuickViewModal();
  }

  openCartDrawer() {
    window.eventBus?.emit('open:cart:drawer', { scrollToTop: true });
  }

  handleQuickViewModal() {
    if (this.closest('[data-quick-view-product]')) {
      const closeModal = () => {
        if (document.body.classList.contains('theme-modal-open')) window.eventBus?.emit('theme:modal:hide');
      };
      if (this.cartAction === 'show_added_message' && this.addedText) setTimeout(closeModal, 1500);
      else closeModal();
    }
  }

  showLoadingState() {
    if (this.qtyErrorMessage) this.qtyErrorMessage.classList.add('hidden');
    this.toggleElements(this.addToCartText, false);
    this.toggleElements(this.loadingIcon, true, 'hidden');
    this.toggleAddButton(true);
  }

  hideLoadingState() {
    this.toggleElements(this.loadingIcon, false, 'hidden');
    this.toggleCartActionDisplay();
  }

  toggleCartActionDisplay() {
    if (this.cartAction === 'show_added_message' && this.addedText) {
      this.addedText.style.display = 'block';
      setTimeout(() => {
        this.toggleAddToCartText(true);
        this.toggleAddButton(false);
        this.updateCartCountIndicator();
      }, 2000);
    } else if (this.cartType === 'drawer' && this.cartAction === 'go_to_or_open_cart') {
      this.toggleAddToCartText(true);
      this.openCartDrawer();
      this.toggleAddButton(false);
      this.updateCartCountIndicator();
    } else {
      this.toggleAddToCartText(true);
      this.toggleAddButton(false);
      window.location = window.routes.cart_url;
    }
  }

  toggleAddToCartText(show) {
    if (this.addedText) this.addedText.style.display = show ? 'none' : 'block';
    if (this.addToCartText) this.addToCartText.style.display = show ? 'block' : 'none';
  }

  toggleElements(element, show, className) {
    if (!element) return;
    if (className) show ? element.classList.remove(className) : element.classList.add(className);
    else element.style.display = show ? 'block' : 'none';
  }

  toggleAddButton(disable = true) {
    const addButton = this.querySelector('[name="add"]');
    if (addButton) addButton.disabled = disable;
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.onSubmitBound);
  }
}

if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);
/******/ })();
;